import React from "react";
import { Modal, ModalBody } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning } from "@fortawesome/free-solid-svg-icons";
import { ModalButton } from "../../ui/buttons";

const CancelFormModal = ({ toggle, isOpen, closeModal }) => {
  return (
    <div style={{ fontFamily: "Nunito", backgroundColor: "#f8f8f8" }}>
      <Modal size="sm" centered isOpen={isOpen}>
        <ModalBody>
          <FontAwesomeIcon icon={faWarning} className="-100" color="red" size="3x" />
          <p
            className="d-block badge-pills h-50 w-100 justify-content-center text-center py-2 mt-2"
            style={{ fontSize: "14px", fontWeight: "normal", fontFamily: "Nunito" }}
          >
            ¿Esta seguro de cancelar?
          </p>
        </ModalBody>
        <div className="d-flex justify-content-end m-3">
          <ModalButton className="btn px-2 py-1 text-center mr-2" onClick={closeModal} type="button">
            No
          </ModalButton>
          <ModalButton
            size="sm"
            className="btn px-2 py-1 text-center"
            style={{ backgroundColor: "red", color: "white" }}
            type="button"
            onClick={() => {
              closeModal();
              toggle();
            }}
          >
            Si
          </ModalButton>
        </div>
      </Modal>
    </div>
  );
};

export default CancelFormModal;
